<template>
  <v-sheet
    id="install"
    class="sheet fill-height"
    height="100%"
  >
    <v-sheet
      v-if="android||ios"
      height="100%"
      class="sheet d-flex flex-column justify-center flex-grow-1 text-center px-8 pb-8"
    >
      <img 
        src="@/assets/start-install-icon.svg"
        class="empty-icon mx-auto"
      >
      <h4 class="title text-h6 mt-12">
        {{ $t('login.install.title') }}
      </h4>
      <p 
        v-if="android" 
        class="text text-body-1 my-8"
      >
        {{ $t('login.install.text.native') }}
      </p>
      <p 
        v-else
        class="text text-body-1 my-8"
      >
        {{ $t('login.install.text.web') }}
      </p>
      <v-btn 
        v-if="android"
        large
        color="primary"
        class="btn-install grey--text text--darken-4 mt-4"
        @click="installApp"
      >
        {{ $t('general.install') }}
      </v-btn> 
      <v-bottom-sheet 
        v-else-if="ios"
        v-model="ios"
        persistent
        hide-overlay
        inset
        class="dialog"
      >
        <v-sheet 
          v-if="safari"
          max-width="320px"
          class="hint pa-4 my-4 mx-auto text-center" 
        >
          <i18n path="login.install.hint.ios" tag="span">
            <v-icon>{{ icons.mdiExportVariant }}</v-icon>
            <b class="text-no-wrap">"{{ $t('login.install.hint.add_homescreen') }}"</b> 
            <v-icon>{{ icons.mdiPlusBox }}</v-icon>
          </i18n>
        </v-sheet>
        <v-sheet 
          v-else
          max-width="320px"
          class="hint pa-4 my-4 mx-auto text-center" 
        >
          <span v-html="formatText($t('login.install.hint.open_in_safari'))" />
        </v-sheet>
      </v-bottom-sheet>
    </v-sheet>
    <v-sheet
      v-else
      class="sheet d-flex flex-column justify-center flex-grow-1 text-center px-8 pb-8"
    >
      <img 
        src="@/assets/start-install-icon.svg"
        class="empty-icon mx-auto"
      >
      <h4 class="title text-h6 mt-12">{{ $t('login.install.subtitle') }}</h4>
      <p class="text text-body-1 my-8">
        {{ $t('login.install.text.desktop') }}
      </p>
      <v-btn 
        v-if="android"
        large
        color="primary"
        class="btn-install grey--text text--darken-4  mt-4"
        @click="installApp"
      >
        {{ $t('general.install') }}
      </v-btn>  
    </v-sheet>
  </v-sheet>
</template>

<style>

  #install .empty-icon {
    max-width: 160px;
  }


</style>

<script>

  // Icons
  import {
    mdiClose,
    mdiExportVariant,
    mdiPlusBox
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { sync } from 'vuex-pathify'
  import device from '@/device';


  export default {
    name: 'Install',

    props: {
      installed: {
        type: Boolean,
        default: true,
      },
      pwa: {
        type: Boolean,
        default: true,
      }
    },

    data: () => ({
      icons: {
        mdiClose,
        mdiExportVariant,
        mdiPlusBox
      },
      android: device.isAndroid,
      ios: device.isIOS,
      safari: device.isMobileSafari,
    }),

    computed: {
      toast: sync('app/toast'),

    },

    methods: {
      ...services,

      async installApp () {
        // link to stores 
        if (device.isAndroid) {
          location.href = 'https://play.google.com/store/apps/details?id=br.com.mobees.parceiro';
          // location.href = 'https://parceiros.stg.mobees.com.br/app-alpha-v2.apk'; // dev fallback
        }else if (device.isIOS) {
          // TODO update link
          // location.href = 'https://www.apple.com/app-store/parceiros-mobees';
        }
      },
    },

    created () {
      
    },

    mounted () {

    },

    directives: {
    },

  }
</script>
